import { InfoCard } from '../../../store-components/InfoCard/InfoCard';

const InfoCardListContainer = (props: any) => {
	return (
		<div className={`${props.blockClass ? `${props.blockClass} vtex-info-card-list-0-x-${props.blockClass}` : ''}`}>
			<InfoCard {...props} blockClass={props.childrenBlockClass} />
		</div>
	);
};

export default InfoCardListContainer;
